"use client"

import useToggleState from "@lib/hooks/use-toggle-state"
import type { StoreCustomer, StoreProductCategory } from "@medusajs/types"
import CartButton from "@modules/layout/components/cart-button"
import CartButtonTemplate from "@modules/layout/components/cart-button/cart-button-template"
import { Menu } from "lucide-react"
import { Suspense } from "react"
import { ExtendedStoreCart } from "types/global"
import AccountButton from "./account-button"
import MenuMobile from "./menu-mobile"
import OrderButton from "./order-button"

type Props = {
  cart: ExtendedStoreCart | null
  customer: StoreCustomer | null
  orderCount: number
  productCategories: StoreProductCategory[]
}

function RightSection({
  cart,
  customer,
  orderCount,
  productCategories,
}: Props) {
  const { state, close, toggle } = useToggleState()

  return (
    <>
      <Suspense fallback={<CartButtonTemplate />}>
        <CartButton cart={cart} />
      </Suspense>
      {customer && (
        <OrderButton customer={customer} orderCount={orderCount ?? 0} />
      )}
      <div className="lg:flex hidden">
        <AccountButton customer={customer} onClose={close} />
      </div>
      <div className="flex lg:hidden lg:pr-0 pr-2">
        <Menu className="cursor-pointer" onClick={toggle} />
        <MenuMobile
          customer={customer}
          state={state}
          onClose={close}
          productCategories={productCategories}
        />
      </div>
    </>
  )
}

export default RightSection
